// eslint-disable-next-line import/prefer-default-export
export const affectationFaceLc = [
  {
    libelle: 'Affectation en LC',
    value: 1,
  },
  {
    libelle: 'Affectation en réseau',
    value: 2,
  },
  {
    libelle: ' Sans affectation',
    value: 3,
  },
];



// WEBPACK FOOTER //
// ./src/configuration/affectationFaceLcFilter.js